import React from "react"
import { UserPromptModal } from "../../../../components/UserPromptModal"
import { FailedRenewalModal } from "../FailedRenewalModal/FailedRenewalModal"
import { useFailedRenewalModal } from "../FailedRenewalModal/useFailedRenewalModal"

export function MemberModals() {
  const { loading, entitlement } = useFailedRenewalModal()

  if (loading) {
    return <></>
  }

  if (entitlement) {
    return <FailedRenewalModal gracePeriodEntitlement={entitlement} />
  }
  return <UserPromptModal />
}
